export default __webpack_public_path__ + "static/media/services.351199fc.jpg";